export default __webpack_public_path__ + "static/media/606-501c3.e8965b78.svg";